import React from 'react';
import { Container, Paper, Typography, Box, Divider } from '@mui/material';
import { PageIndices } from '../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '../components/DashboardLayout';
import { DevAiTest } from '../components/development/DevAiTest';
import { DevAiPromptsTest } from '../components/development/DevAiPromptsTest';
import { Science } from '@mui/icons-material';

const AiTestPage: React.FC = () => {
  return (
    <DashboardLayout onChangePassword={() => {}}>
      <Container maxWidth="lg" data-i-doc={PageIndices.AI_TEST}>
        <Paper sx={{ mt: 3, p: 4, borderRadius: '16px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Science color="primary" fontSize="large" />
            <Typography variant="h4" fontWeight={700}>
              Тестування AI Можливостей
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" paragraph>
            Ця сторінка призначена для технічної перевірки зв'язку з сервісами штучного інтелекту (Gemini). 
            Використовуйте її для діагностики перед впровадженням нових функцій.
          </Typography>
          
          <DevAiTest />

          <Divider sx={{ my: 4 }} />

          <DevAiPromptsTest />
        </Paper>
      </Container>
    </DashboardLayout>
  );
};

export default AiTestPage;
